import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Store } from '@ngrx/store';
import { format} from 'date-fns';
import { ModalService } from 'src/app/services/modal.service';
import { createSeasonLeague } from 'src/app/store/actions/tournament.action';
import { AppState } from 'src/app/store/app.state';

@Component({
  selector: 'app-create-league',
  templateUrl: './create-league.component.html',
  styleUrls: ['./create-league.component.scss']
})
export class CreateLeagueComponent implements OnInit {

  season!: any;

  form: FormGroup;

  constructor(
    private modalService: ModalService,
    private fb: FormBuilder,
    private store: Store<AppState>
  ) { }

  ngOnInit() {
    console.log(this.season);
    
    this.form = this.fb.group({
      name: ['', Validators.required],
      leagueStart: ['', Validators.required],
      leagueEnd: ['', Validators.required],
      leagueDeadline: ['', Validators.required],
      leagueOpen: ['', Validators.required],
      ratingMinimum: ['', Validators.required],
      ratingMaximum: ['', Validators.required],
      players: ['', Validators.required],
      leagueCategory: ['', Validators.required],
      leagueType: ['', Validators.required],
      leagueRound: ['', new FormControl()],
    })
  }

  createSeasonLeague(){
    const startValue = this.leagueStart?.value;
    const endValue = this.leagueEnd?.value;
    const deadlineValue = this.leagueDeadline?.value;

    const startDate = new Date(startValue);
    const endDate = new Date(endValue);
    const deadline = new Date(deadlineValue);
    
    if (endDate < startDate) {
      console.error("Invalid End Date: Must be after or equal to Start Date");
      return;
    }

    const payload = {
      seasonId: this.season.seasonId,
      name: this.name?.value,
      leagueStart: format(this.leagueStart?.value, 'yyyy-MM-dd'),
      leagueEnd: format(this.leagueEnd?.value, 'yyyy-MM-dd'),
      leagueDeadline: format(this.leagueDeadline?.value, 'yyyy-MM-dd'),
      leagueOpen: this.leagueOpen?.value,
      ratingMinimum: this.ratingMinimum?.value,
      ratingMaximum: this.ratingMaximum?.value,
      players: this.players?.value,
      leagueCategory: this.leagueCategory?.value,
      leagueType: this.leagueType?.value,
      leagueRound: this.leagueRound?.value,
    }

    console.log(payload);
    this.store.dispatch(createSeasonLeague({data: payload}));
  }

  get name(){
    return this.form.get('name');
  }

  get status(){
    return this.form.get('status');
  }

  get leagueStart(){
    return this.form.get('leagueStart');
  }

  get leagueEnd(){
    return this.form.get('leagueEnd');
  }

  get leagueDeadline(){
    return this.form.get('leagueDeadline');
  }

  get leagueOpen(){
    return this.form.get('leagueOpen');
  }

  get ratingMinimum(){
    return this.form.get('ratingMinimum');
  }

  get ratingMaximum(){
    return this.form.get('ratingMaximum');
  }

  get players(){
    return this.form.get('players');
  }

  get leagueCategory(){
    return this.form.get('leagueCategory');
  }

  get leagueType(){
    return this.form.get('leagueType');
  }

  get leagueRound(){
    return this.form.get('leagueRound');
  }

  close(){
    this.modalService.hideCreateSeasonLeague();
  }

  dateToday = new Date(); 

}
